import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  ClientDetailDto,
  ClientLocationDto,
  ClientPurchasedPackageDto,
} from "src/store/clients/type";
import DataGrid from "src/components/Page/Datagrid";
import {
  deleteClientLocation,
  getClientLocationDetail,
  getClientLocations,
} from "src/store/clients/saga";
import LocationEditForm from "./edit";
import LocationCreateForm from "./create";
import { onSuccessClickFormBasicForm } from "src/helpers/onSuccess";
const ClientLocationsTab = ({
  client,
  active,
}: {
  active: string;
  client: ClientDetailDto;
}) => {
  const { t } = useTranslation();
  const [dataList, setDataList] = useState<ClientLocationDto[]>([]);
  const dispatch = useDispatch();
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [selected, setSelected] = useState<ClientLocationDto>();
  const columns = [
    {
      text: t("Clients.Locations.Title"),
      dataField: "LocationTitle",
    },
    {
      text: t("Clients.Locations.Country"),
      dataField: "Country",
    },
    {
      text: t("Clients.Locations.City"),
      dataField: "City",
    },
    {
      text: t("Clients.Locations.Default"),
      dataField: "Default",
      formatter: (cellContent: boolean) =>
        cellContent ? (
          <i className="text-success bx  bx-check-square"></i>
        ) : (
          <i className="text-danger mdi mdi-close-box-outline"></i>
        ),
    },
  ];

  return (
    <React.Fragment>
      {active === "3" && (
        <DataGrid
          hideBreadcrumbs
          isDetails
          listData={dataList}
          setDataList={setDataList}
          action={getClientLocations}
          paramsid={client.Id}
          addTitle={t("Clients.Locations.AddButton").toString()}
          onCreateClick={() => setShowCreate(true)}
          columns={columns}
          editButton={{
            onClick: (id, data) => {
              dispatch(
                getClientLocationDetail({
                  payload: {
                    onSuccess: (message, payload, response) => {
                      let currenctObject = payload;
                      setSelected(currenctObject);
                      return setShowEdit(true);
                    },
                    onError: () => {},
                  },
                  id: id,
                })
              );
            },
          }}
          deleteButton={{
            text: (id, data: ClientLocationDto) =>
              t("Clients.Locations.DeleteQA"),
            action: deleteClientLocation,
            onClick: (id, data) => setShowEdit(data),
          }}
        />
      )}
      <LocationCreateForm
        open={showCreate}
        client={client}
        onHide={() => setShowCreate(false)}
        onSuccessClick={(m) =>
          onSuccessClickFormBasicForm({
            dispatch: dispatch,
            message: m,
            action: getClientLocations,
            setDataList: setDataList,
            id: client.Id,
          })
        }
      />
      {selected && (
        <LocationEditForm
          data={selected}
          open={showEdit}
          onHide={() => {
            setShowEdit(false);
            return setSelected(undefined);
          }}
          onSuccessClick={(m) =>
            onSuccessClickFormBasicForm({
              dispatch: dispatch,
              message: m,
              action: getClientLocations,
              setDataList: setDataList,
              id: client.Id,
            })
          }
        />
      )}
    </React.Fragment>
  );
};

export default ClientLocationsTab;
